
import { useEffect } from 'react'

// Chakra imports
import { Flex, useColorModeValue } from '@chakra-ui/react';

import { useHistory } from "react-router-dom";
import useAuthContext from "hooks/useAuthContext";

import { LAYOUT_PUBLICO, LAYOUT_PRIVADO, PATH_LOGIN, PATH_HOME, ROL_ADMINISTRATOR } from "const/CommonConst";

export default function Default() {	
	useEffect(() => document.title = `Taurel - Servicios en Línea`,[]);

	const history = useHistory();

	const {isAuthenticate, checkExpired, logout, hasAccess} = useAuthContext();
  
	useEffect(async () => {
	  if (!isAuthenticate || await checkExpired()){
		  logout();
		  history.push(`${LAYOUT_PUBLICO}${PATH_LOGIN}`);
	  }
	}, []); 
	
	const paleGray = useColorModeValue('secondaryGray.400', 'whiteAlpha.100');
	return (
		<Flex direction={{ base: 'column', xl: 'row' }} pt={{ base: '130px', md: '80px', xl: '80px' }}>
			Working in progress (USER)...
		</Flex>
	);
}
